module.exports = __webpack_public_path__ + "img/sync-disabled.e9e81544.svg";